import React from 'react'

const StepsSection = ({ steps }) => {
    return (
        <div className="max-w-2xl mx-auto">
            <div className="flex flex-col items-start relative space-y-12">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="flex h-full relative items-start">
                        <div className="flex h-full flex-col items-center mr-4 ">
                            <div className="flex items-center justify-center w-12 h-12 bg-olm-light-secondary border-primary border-2 rounded-full">
                                <span className="text-lg font-semibold text-orange-600">
                                    {index + 1}
                                </span>
                            </div>
                            {index !== steps.length - 1 && (
                                <div className="absolute w-1 h-full top-12 bg-primary"></div>
                            )}
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold">{step.title}</h3>
                            <p className="text-base">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StepsSection
